import React from 'react';
export function Inkster() {
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-187">
      <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-188">Inkster, MI</h1>
      <p className="text-xl text-gray-600" data-id="element-189">Area Service Page Coming Soon</p>
    </div>;
}